import { render, staticRenderFns } from "./extraMails.vue?vue&type=template&id=20deae1c&scoped=true&"
import script from "./extraMails.vue?vue&type=script&lang=js&"
export * from "./extraMails.vue?vue&type=script&lang=js&"
import style0 from "./extraMails.vue?vue&type=style&index=0&id=20deae1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20deae1c",
  null
  
)

export default component.exports